import { types } from "../action-types";

const initialState = {
  loading: false,
  projects: [],
  pagination: {},
  error: false,
};

const fetchProjectsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_PROJECTS_INIT:
      return { ...state, loading: true, error: false };
    case types.FETCH_PROJECTS_SUCCESS:
      return {
        ...state,
        loading: false,
        projects: action.payload.projects,
        pagination: action.payload.pagination,
      };
    case types.FETCH_PROJECTS_FAILURE:
      return { ...state, loading: false, error: true };
    default:
      return state;
  }
};

export default fetchProjectsReducer;
